import { MINIMUM_DEBOUNCE_INTERVAL } from '../../../core/constants'

export const DEFAULT_OPTIONS = {
  on: 'scroll',
  interval: MINIMUM_DEBOUNCE_INTERVAL
}
